/**
 * A FAMÍLIA ÚNICA DE ÍCONES do InovaPay 2.0 — "iconografia única no lugar dos emojis de
 * navegação" (design, tela 01). Os desenhos são os do próprio mockup, traço a traço.
 *
 * Um sprite só, montado uma vez na raiz (`<SpriteDeIcones />`), e cada ícone é um `<use>`.
 * Assim o desenho não se repete no DOM e a cor vem do `currentColor` de quem usa.
 *
 * Ícone é decorativo por padrão (`aria-hidden`). Quando ele é a ÚNICA indicação de algo, quem
 * usa passa `rotulo` — e o leitor de tela ouve o rótulo, não "imagem".
 */

const DESENHOS = {
  // Tela 04 — Login
  user: 'M10 9.8a3.15 3.15 0 1 0 0-6.3 3.15 3.15 0 0 0 0 6.3ZM3.9 17c.6-3 3.1-4.7 6.1-4.7s5.5 1.7 6.1 4.7',
  lock: 'M5.6 9V7.2a4.4 4.4 0 0 1 8.8 0V9M4.6 9h10.8v8H4.6z',
  eye: 'M10 4.6c4 0 7.4 5.4 7.4 5.4S14 15.4 10 15.4 2.6 10 2.6 10 6 4.6 10 4.6ZM10 12.4a2.4 2.4 0 1 0 0-4.8 2.4 2.4 0 0 0 0 4.8Z',
  arrow: 'M4 10h12M11.5 5.5 16 10l-4.5 4.5',
  warn: 'M10 3.2 17.2 16.4H2.8ZM10 8v3.6M10 13.7v.7',
  clock: 'M10 17.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM10 6v4.3l2.9 1.7',
  wifi: 'M3.2 7.4a12 12 0 0 1 4.3-2.5M12.6 5a12 12 0 0 1 4.2 2.4M6.2 10.8a7.6 7.6 0 0 1 2-1.1M11.9 9.8a7.6 7.6 0 0 1 1.9 1M10 15.2v.1M3 3l14 14',
  caps: 'M10 3.4 16 10h-3.2v4.2H7.2V10H4ZM7.2 16.8h5.6',
  check: 'M4.2 10.4 8 14.2l7.8-8.4',
  phone: 'M6.6 2.8h6.8v14.4H6.6zM9 15.2h2',
  hash: 'M7.6 3.4 6.4 16.6M13.6 3.4l-1.2 13.2M3.6 7.4h13M3 12.6h13',
  brief: 'M3.2 6.4h13.6v9.8H3.2zM7.4 6.4V4.2h5.2v2.2M3.2 10.6h13.6',
  // Tela 02 — Shell (menu, topbar, navegacao)
  grid: 'M3.5 3.5h5.2v5.2H3.5zM11.3 3.5h5.2v5.2h-5.2zM3.5 11.3h5.2v5.2H3.5zM11.3 11.3h5.2v5.2h-5.2z',
  receipt: 'M5 2.6h10v14.8l-2.5-1.5-2.5 1.5-2.5-1.5L5 17.4ZM7.6 6.6h4.8M7.6 9.6h4.8M7.6 12.6h3',
  cycle: 'M4 10a6 6 0 0 1 10.3-4.2M16 10a6 6 0 0 1-10.3 4.2M14.6 3.1v2.9h-2.9M5.4 16.9v-2.9h2.9',
  money:
    'M2.6 5.8h14.8v8.4H2.6ZM10 12.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4ZM5.4 9.95v.1M14.6 9.95v.1',
  box: 'M10 2.7 17 6v8l-7 3.3L3 14V6ZM3 6l7 3.3L17 6M10 9.3v8',
  users:
    'M7.6 9.2a2.85 2.85 0 1 0 0-5.7 2.85 2.85 0 0 0 0 5.7ZM2.6 16.6c0-2.6 2.2-4.2 5-4.2s5 1.6 5 4.2M13.2 4.3a2.7 2.7 0 0 1 0 4.9M14.6 12.7c1.9.4 3 1.7 3 3.9',
  file: 'M5.2 2.6h6.3L15 6.2v11.2H5.2ZM11.5 2.6v3.6H15M7.7 10h4.6M7.7 13h4.6',
  gauge: 'M3.2 14.4a7.2 7.2 0 1 1 13.6 0M10 14l3.3-4',
  shield: 'M10 2.8 16 5v5c0 4-2.8 6.2-6 7.2-3.2-1-6-3.2-6-7.2V5ZM7.6 9.8l1.9 1.9 3.1-3.3',
  cog: 'M10 12.6a2.6 2.6 0 1 0 0-5.2 2.6 2.6 0 0 0 0 5.2ZM10 2.8v1.8M10 15.4v1.8M2.8 10h1.8M15.4 10h1.8M4.9 4.9l1.3 1.3M13.8 13.8l1.3 1.3M15.1 4.9l-1.3 1.3M6.2 13.8l-1.3 1.3',
  bell: 'M10 3a4.5 4.5 0 0 1 4.5 4.5c0 3 .8 4 1.5 5H4c.7-1 1.5-2 1.5-5A4.5 4.5 0 0 1 10 3ZM8.2 15.4a1.85 1.85 0 0 0 3.6 0',
  search: 'M9 15.2a6.2 6.2 0 1 0 0-12.4 6.2 6.2 0 0 0 0 12.4ZM13.6 13.6l3.7 3.7',
  'chev-d': 'M5.4 8 10 12.6 14.6 8',
  'chev-r': 'M8 5.4 12.6 10 8 14.6',
  panel: 'M3.2 4.6h13.6v10.8H3.2zM7.6 4.6v10.8',
  dots: 'M10 5.2v.1M10 9.95v.1M10 14.7v.1',
  plus: 'M10 4.2v11.6M4.2 10h11.6',
  filter: 'M3 5.2h14M5.6 10h8.8M8.4 14.8h3.2',
  cal: 'M4 5.4h12v11.2H4zM7 3.2v2.2M13 3.2v2.2M4 9h12',
  down: 'M10 3.2v9.1M6.5 8.8 10 12.3l3.5-3.5M4 16.6h12',
  trophy:
    'M6.6 3.4h6.8v3.2a3.4 3.4 0 0 1-6.8 0ZM6.6 4.5H4.4a2.2 2.2 0 0 0 2.2 2.4M13.4 4.5h2.2a2.2 2.2 0 0 1-2.2 2.4M10 10v3.4M7.2 16.6h5.6l-.6-3.2H7.8Z',
  x: 'M5.2 5.2l9.6 9.6M14.8 5.2 5.2 14.8',
  'up-t': 'M10 15.4V5M6.2 8.8 10 5l3.8 3.8',
  menu: 'M3.4 5.6h13.2M3.4 10h13.2M3.4 14.4h13.2',
  cam: 'M3.4 6.6h3L7.9 4.6h4.2l1.5 2h3v9.8h-13ZM10 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  // Telas 31–33 (equipe, aprovações, perfis)
  key: 'M12.6 3.4a4.2 4.2 0 1 1-3.1 7l-.9.9H6.8v1.8H5v1.8H2.6v-2.4l6-6a4.2 4.2 0 0 1 4-3.1ZM13.4 6.6v.1',
  pin: 'M10 17.4S4.6 12.6 4.6 8.6a5.4 5.4 0 0 1 10.8 0c0 4-5.4 8.8-5.4 8.8ZM10 10.6a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z',
  retry: 'M16.2 10a6.2 6.2 0 1 1-1.9-4.4M16.4 3.2v3.2h-3.2',
  'arrow-l': 'M16 10H4M8.5 5.5 4 10l4.5 4.5',
  // Bloco 7 (tela 08): tipo vitamina, quantidade, foto do produto, sem conexão.
  pill: 'M7.4 12.6 12.6 7.4M5.8 14.2a3.8 3.8 0 0 1 0-5.4l3-3a3.8 3.8 0 0 1 5.4 5.4l-3 3a3.8 3.8 0 0 1-5.4 0Z',
  minus: 'M4.2 10h11.6',
  edit: 'M4 16l.9-3.7 8.5-8.5a1.4 1.4 0 0 1 2 0l.8.8a1.4 1.4 0 0 1 0 2l-8.5 8.5ZM12.2 5l2.8 2.8',
  // Bloco 11 (telas 22–24): scanner da recontagem, banco (fonte do backend) e prateleira.
  scan: 'M3 6.4V3.4h3M14 3.4h3v3M17 13.6v3h-3M6 16.6H3v-3M6.6 7v6M9.2 7v6M11.8 7v6M14 7v6',
  db: 'M10 6.2c3.4 0 6.2-.9 6.2-2S13.4 2.2 10 2.2 3.8 3.1 3.8 4.2s2.8 2 6.2 2ZM3.8 4.2v11.6c0 1.1 2.8 2 6.2 2s6.2-.9 6.2-2V4.2M3.8 10c0 1.1 2.8 2 6.2 2s6.2-.9 6.2-2',
  shelf: 'M3 4.4h14M3 10h14M3 15.6h14M6.4 4.4v5.6M11.6 10v5.6',
  image: 'M3.4 4.4h13.2v11.2H3.4zM3.4 12.6 7 9.4l3 2.6 3.2-3 3.4 3',
  offline:
    'M3.2 7.4a12 12 0 0 1 4.3-2.5M12.6 5a12 12 0 0 1 4.2 2.4M6.2 10.8a7.6 7.6 0 0 1 2-1.1M11.9 9.8a7.6 7.6 0 0 1 1.9 1M10 15.2v.1M3 3l14 14',
  // Encomendas → Registrar falta (02/10): "o produto faltou" (círculo com x) e "encomendar" (caixa com +).
  falta: 'M10 17.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4ZM7.5 7.5l5 5M12.5 7.5l-5 5',
  encomendar: 'M10 2.7 17 6v3.4M3 6v8l7 3.3M3 6l7 3.3L17 6M10 9.3v8M15.2 12.4v5.2M12.6 15h5.2',
  // Geladeira (19/10): floco de neve — as canetas que vivem no frio.
  gelo: 'M10 2.5v15M3.5 6.25l13 7.5M3.5 13.75l13-7.5M7.8 3.6 10 5.4l2.2-1.8M7.8 16.4 10 14.6l2.2 1.8M3.9 9.1l2.7.9-.5 2.8M16.1 10.9l-2.7-.9.5-2.8',
} as const;

// Traço proprio de alguns desenhos do mockup (o resto usa o traço de quem chama).
const TRACO_PROPRIO: Partial<Record<keyof typeof DESENHOS, number>> = {
  money: 1.6,
  dots: 2.6,
};

export type NomeDoIcone = keyof typeof DESENHOS;

export function SpriteDeIcones() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true" focusable="false">
      <defs>
        {Object.entries(DESENHOS).map(([id, d]) => (
          <symbol key={id} id={`i-${id}`} viewBox="0 0 20 20">
            <path d={d} strokeWidth={TRACO_PROPRIO[id as NomeDoIcone]} />
          </symbol>
        ))}
      </defs>
    </svg>
  );
}

export function Icone({
  nome,
  tamanho = 18,
  rotulo,
  traco = 1.6,
}: {
  nome: NomeDoIcone;
  tamanho?: number;
  rotulo?: string;
  traco?: number;
}) {
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 20 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={traco}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ flex: 'none' }}
      {...(rotulo ? { role: 'img', 'aria-label': rotulo } : { 'aria-hidden': true })}
    >
      <use href={`#i-${nome}`} />
    </svg>
  );
}
